import Vue from 'vue'
import Router from 'vue-router'
import {goTop} from '../util'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

//解决方案模块
import solution from './module/solution';
//服务中心模块
import serviceCentre from './module/serviceCentre';
// 优势产品模块
import goodQuality from './module/goodQuality';
// 行业资讯模块
import industryConsultation from './module/industryConsultation';
// 关于我们模块
import aboutUs from './module/aboutUs';
// CMS
import CMS from './module/CMS';

const indexRouter = [
  {
    path: '/home', name: 'home',
    component: () => import('@/pages/home'),
  }
];
// const totalChildRouter = indexRouter.concat(goodQuality,serviceCentre,solution,industryConsultation, aboutUs);

//2.0版本代码
import newRouter from './module3.0'
const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'navbar',
    //   redirect: '/home',
    //   component: () => import('@/components/navbar'),
    //   children: totalChildRouter
    // },
    {
      path: '/',
      name: 'index',
      redirect: '/home',
      component: () => import('@/pages3.0/index'),
      children: newRouter
    },
    ...CMS,

  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next('/home') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
  }
  if(!to.hash){// 有锚点
    goTop()// 回顶
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js